module.exports = __webpack_public_path__ + "static/media/Transaction-risk-engine Risk Decision Page.5cae1e8b.png";